import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  flex: {
    flex: 1
  },
  flexDouble: {
    flex: 2
  },
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 20,
    paddingHorizontal: 20,
    backgroundColor: '#fff',
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 3,
  },
  webCalendarContainer: {
    flex: 1,
  },
  modernButtonContainer: {
    marginHorizontal: 6,
  },
  modernButton: {
    paddingHorizontal: 22,
    paddingVertical: 14,
    borderRadius: 25,
    borderWidth: 2,
    minWidth: 85,
    elevation: 3,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 5,
  },
  modernButtonContent: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  selectedIcon: {
    textShadowColor: 'rgba(0, 0, 0, 0.3)',
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 2,
  },
  unselectedIcon: {
    // Pas d'ombre pour les icônes non-sélectionnées
  },
  openMenuIcon: {
    textAlign: 'center',
    width: 120,
    height: 40,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    borderWidth: 1,
    borderColor: '#c0c6d0',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row'
  },
  title: {
    fontSize: 16
  },
  inputContainer:{
    width:"25%"
  },
  input: {
    flex: 1,
    padding: 4,
    borderRadius: 5,
    margin: 0,
    borderWidth: 0,
    textAlign: 'center',
    
  },
  validationButton: {
    flex: 1,
    backgroundColor: '#3b82f6',
    paddingVertical: 16,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonList: {
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: '#E1E1E1',
    borderRadius: 5,
    borderWidth: 0.2,
    borderStyle: 'solid',
    borderColor: 'white',
  },
  dateContainer: {
    gap: 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
    flex: 3,
  },
  vacancesContainer : {
    flexDirection: 'row',
    justifyContent:'center',
    alignItems: 'center',
    flex: 1
  },
  modalContent: {
    gap: 10,
    width: '50%',
    alignSelf: 'center',
  }
});

export default styles
